// extracted by mini-css-extract-plugin
export default {"main":"NextCaseStudies_main__MraNm","contentCol":"NextCaseStudies_contentCol__hxJw3"};